<template>
	<table-run
		include-options
		:columns="columns"
		:rows="rows"
		:include-delete="false"
		:include-search="false"
		:include-export-to-excel="false"
		:selectable="false"
		:option-buttons="optionButtonsCheckin"
		@custom-button="customButtons"
		class="no-selectable-table">
		<template slot="rows" scope="props">
			<td>{{props.row.numReservation}}</td>
			<td>{{props.row.name}} {{props.row.lastname}}</td>
			<td>{{getChannelName(props.row)}}</td>
			<td>{{props.row.country}}</td>
			<td>{{props.row.roomType}}<br>{{props.row.codeRoom}}</td>
			<td class="td-state">
				<span
					:style="customColor(props.row)"
				>
					{{props.row.paymentStatus}}
				</span>
			</td>
			<td>{{props.row.dateEnd}}<br>{{props.row.dateEndHours}}</td>
			<td>{{props.row.employee}}</td>
			<td>{{props.row.total}}</td>
		</template>
	</table-run>
</template>

<script>
import TableRun from 'table-run';
import lib from '@/shared/lib';

const { getDeeper } = lib;

function customButtons({ row }) {
	this.$emit('actions', row);
}

function customColor({ colorsPayment }) {
	return `color: ${colorsPayment}`;
}

function getChannelName(row) {
	return getDeeper('channel', 'data', 'name')(row);
}

export default {
	name: 'report-table',
	components: {
		TableRun,
	},
	methods: {
		customButtons,
		customColor,
		getChannelName,
	},
	props: {
		columns: {
			default: () => [],
			type: Array,
		},
		optionButtonsCheckin: {
			default: () => [],
			type: Array,
		},
		rows: {
			default: () => [],
			type: Array,
		},
	},
};
</script>




// WEBPACK FOOTER //
// report-table.vue?2cb6e518